var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSnakeB(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 126,
    height: 88,
    viewBox: "0 0 126 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.44195 5.02105C-0.0435181 8.1254 0.424011 12.8174 4.11131 14.3068C9.72456 16.5742 14.8948 15.9967 18.9573 15.546C23.9073 14.997 26.2294 14.853 29.3794 17.373C32.5204 19.893 32.8984 22.188 33.4384 27.147C34.0414 32.664 34.8693 40.224 42.8073 46.587C50.7453 52.95 58.3054 52.104 63.8224 51.492C68.7724 50.943 71.0943 50.799 74.2443 53.319C77.3853 55.839 77.7633 58.134 78.3033 63.084C78.9063 68.601 79.7344 76.161 87.6724 82.524C95.6104 88.887 103.17 88.041 108.687 87.429C110.129 87.2691 111.348 87.1436 112.429 87.1082C116.404 86.9782 121.124 86.7398 123.61 83.635C126.095 80.5307 125.628 75.8387 121.94 74.3492C116.327 72.0818 111.157 72.6594 107.094 73.11C102.144 73.659 99.8224 73.803 96.6724 71.283C93.5314 68.763 93.1534 66.468 92.6134 61.518C92.0104 56.001 91.1823 48.441 83.2443 42.078C75.3063 35.715 67.7464 36.561 62.2294 37.173C57.2794 37.722 54.9573 37.866 51.8073 35.346C48.6573 32.826 48.2883 30.531 47.7483 25.572C47.1453 20.055 46.3174 12.495 38.3794 6.13202C30.4414 -0.230976 22.8814 0.615027 17.3644 1.22703C15.9226 1.38693 14.7038 1.51248 13.6225 1.54785C9.6474 1.67788 4.92774 1.91629 2.44195 5.02105Z",
    fill: "#233646"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnakeB);
export default __webpack_public_path__ + "static/media/snake-b.eef11ecf77bf9a9bda446193a0c37e30.svg";
export { ForwardRef as ReactComponent };